const UrlSwitch = (() => {
    const Selectors = {
        LINK: 'data-redirect-href'
    };
    class UrlSwitch {
        constructor() {
            this.changeUrls();
        }

        changeUrls() {
            const elements = document.querySelectorAll(`[${Selectors.LINK}]`);
            elements.forEach(element =>{
                let link = element.getAttribute(Selectors.LINK);
                element.setAttribute('href', link)
            })
        }
    }

    return new UrlSwitch();

})();

export default UrlSwitch;
